import React, { useMemo } from 'react';
import Select from 'react-select';
import InclusionHeaderRow from '../common/InclusionHeaderRow';
import InclusionDetailCard from '../common/InclusionDetailCard';

const TransferInclusion = ({
    disabled,
    isTransferIncluded,
    transfersightseeinglistdata,
    transferSightseeingDetail,
    handletransfersightseeingchange,
    transferSightseeingdisable,
    transferSightseeingopen,
    handleTransferSightseeing,
    transferSupplierDetail,
    onChangeDropdown,
    transferSuppliervehicleDetail,
    handleRemoveTransferVehicle,
    formerror
}) => {
    const selectedSupplier = useMemo(
        () => transferSupplierDetail?.find(item => item.value === transferSightseeingDetail?.TransferSupplierId) || null,
        [transferSupplierDetail, transferSightseeingDetail?.TransferSupplierId]
    );

    const selectedVehicle = useMemo(
        () => transferSuppliervehicleDetail?.find(item => item.value === transferSightseeingDetail?.TransferVehicleDetailId) || null,
        [transferSuppliervehicleDetail, transferSightseeingDetail?.TransferVehicleDetailId]
    );

    const formattedPrice = useMemo(() => {
        const p = transferSightseeingDetail?.TransferVehiclePrice;
        if (p !== undefined && p !== null && p !== '' && transferSightseeingDetail?.TransferVehicleDetailId > 0) {
            return `₹${p}`;
        }
        return '';
    }, [transferSightseeingDetail?.TransferVehiclePrice, transferSightseeingDetail?.TransferVehicleDetailId]);

    const isTransferSelected = transferSightseeingDetail?.TransferSightseeingId > 0;
    const isSupplierSelected = transferSightseeingDetail?.TransferSupplierId > 0;
    const isVehicleSelected = transferSightseeingDetail?.TransferVehicleDetailId > 0;

    return (
        <>
            <InclusionHeaderRow
                label="Add Transfers"
                required={isTransferIncluded}
                datalist={transfersightseeinglistdata}
                fieldid={transferSightseeingDetail?.TransferSightseeingId}
                onSelectionChange={(e) => handletransfersightseeingchange(e, 'Transfers')}
                isDisabled={disabled || !isTransferIncluded}
                isActiveDisable={transferSightseeingdisable}
                isSearchable
                isOpen={transferSightseeingopen}
                onToggle={() => handleTransferSightseeing("Transfers")}
                buttonDisabled={!isTransferIncluded}
            />

            {transferSightseeingopen && (
                <InclusionDetailCard
                    title={transferSightseeingDetail?.TransferSightseeingName}
                    pickupPoint={transferSightseeingDetail?.TransferSightseeingPickupPoint}
                    dropPoint={transferSightseeingDetail?.TransferSightseeingDropPoint}
                    duration={transferSightseeingDetail?.TransferSightseeingDuration}
                    itineraryDetails={transferSightseeingDetail?.TransferSightseeingItineraryDetails}
                    timePickerId="TransferSightseeingDuration"
                />
            )}

            <div className="col-lg-6 col-sm-6">
                <div className="row">
                    <div className="col-lg-4 col-md-12 mb-1">
                        <label className={`col-form-label ${isTransferSelected ? 'required' : ''}`}>
                            Select Supplier
                        </label>
                    </div>
                    <div className="col-lg-8 mb-1 col-md-12">
                        <Select
                            className="dropdown select_dropdown"
                            options={transferSupplierDetail}
                            name="TransferSupplierId"
                            value={selectedSupplier}
                            onChange={(e) => onChangeDropdown('TransferSupplierId', e)}
                            isDisabled={disabled || !isTransferSelected}
                            isSearchable
                        />
                        {formerror?.TransferSupplierId && <p className="text-danger text-start">{formerror.TransferSupplierId}</p>}
                    </div>
                </div>
            </div>

            <div className="col-lg-6 col-sm-6">
                <div className="row">
                    <div className="col-lg-4 col-md-12 mb-1">
                        <label className={`col-form-label ${isSupplierSelected ? 'required' : ''}`}>
                            Add Vehicle
                        </label>
                    </div>
                    <div className="col-lg-8 mb-1 col-md-12">
                        <Select
                            className="dropdown select_dropdown"
                            options={transferSuppliervehicleDetail}
                            name="TransferVehicleDetailId"
                            value={selectedVehicle}
                            onChange={(e) => onChangeDropdown('TransferVehicleDetailId', e)}
                            isDisabled={disabled || !isSupplierSelected}
                            isSearchable
                        />
                        {formerror?.TransferVehicleDetailId && <p className="text-danger text-start">{formerror.TransferVehicleDetailId}</p>}
                    </div>
                </div>
            </div>

            {/* 4 Auto-filled Read-only Capacity & Price Fields */}
            <div className="col-12 mt-2">
                <div className="row align-items-center">
                    <div className="col-lg-3 col-md-6 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-5">
                                <label className="col-form-label mb-0">Max Adult (cap)</label>
                            </div>
                            <div className="col-sm-7">
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                    disabled
                                    value={transferSightseeingDetail?.TransferMaxAdultCap ?? ''}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-5">
                                <label className="col-form-label mb-0">Free Infants (cap)</label>
                            </div>
                            <div className="col-sm-7">
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                    disabled
                                    value={transferSightseeingDetail?.TransferFreeInfantsCap ?? ''}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <label className="col-form-label mb-0">Max Total (cap) (Adult + Child)</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                    disabled
                                    value={transferSightseeingDetail?.TransferMaxTotalCap ?? ''}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-2">
                        <div className="row align-items-center">
                            <div className="col-sm-4">
                                <label className="col-form-label mb-0">Price</label>
                            </div>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                    disabled
                                    value={formattedPrice}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <small className="text-muted">
                            Select supplier, then vehicle: the four fields above fill automatically and a row drops into the grid below.
                        </small>
                    </div>
                </div>
            </div>

            {/* Transfer Vehicle Grid */}
            {isVehicleSelected && (
                <div className="col-12">
                    <div className="my-3 row form_border py-3">
                        <div className="col-lg-12 mb-1 table-scrollable">
                            <table id="data" className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Supplier Name</th>
                                        <th>Vehicle Name</th>
                                        <th>Max Adult (cap)</th>
                                        <th>Max Total (cap)</th>
                                        <th>Free Infants (cap)</th>
                                        <th>Vehicle Price</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody id="location-data">
                                    <tr className="ReactTable">
                                        <td>{transferSightseeingDetail?.TransferSupplierName}</td>
                                        <td>{transferSightseeingDetail?.TransferVehicleName}</td>
                                        <td>{transferSightseeingDetail?.TransferMaxAdultCap ?? '-'}</td>
                                        <td>{transferSightseeingDetail?.TransferMaxTotalCap ?? '-'}</td>
                                        <td>{transferSightseeingDetail?.TransferFreeInfantsCap ?? '-'}</td>
                                        <td>{formattedPrice || '-'}</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link text-danger p-0"
                                                onClick={handleRemoveTransferVehicle}
                                                disabled={disabled}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(TransferInclusion);

